import type { ItemInstance } from "@headless-tree/core"
import { IconButton, LuIcon } from "@overmap-ai/blocks"
import type { ComponentPropsWithRef } from "react"

import { modelIconMapping } from "../../../mappings/icons"
import { genericMemo } from "../../../utils/optimization"

interface TreeExpandedButtonProps<T> extends ComponentPropsWithRef<typeof IconButton> {
	item: ItemInstance<T>
}

export const TreeExpandedButton = genericMemo(function <T>(props: TreeExpandedButtonProps<T>) {
	const { ref, item, ...rest } = props

	return (
		<IconButton ref={ref} {...rest}>
			<LuIcon icon={!item.isExpanded() ? modelIconMapping.chevronRight : modelIconMapping.chevronDown} />
		</IconButton>
	)
})
